/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AdminReservationDto, PaymentDto, ReservationDayOfWeekDto } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class AdminReservationService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 지정된 기간의 예약 목록을 엑셀 파일로 내보냅니다.
   *
   * @tags AdminReservationService
   * @name ExportReservationsByPeriod
   * @summary 예약 목록 엑셀 내보내기
   * @request POST:/v1/admin/reservations/period/export
   * @secure
   */
  exportReservationsByPeriod = (
    query: {
      /** @format int64 */
      listingId?: number;
      /** @format date */
      fromDate: string;
      /** @format date */
      toDate: string;
      periodType: 'RESERVATION' | 'ARRIVAL' | 'DEPARTURE' | 'CANCELED' | 'CONFIRMATION';
      status?: 'NEW' | 'CONFIRMED' | 'FAILED' | 'CANCELLED';
      onlyGuestNote?: boolean;
      searchKeyword?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/v1/admin/reservations/period/export`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminReservationService
   * @name GetReservations
   * @summary Get Reservations
   * @request GET:/v1/admin/reservations
   * @secure
   */
  getReservations = (
    query?: {
      /** @format date */
      arrivalDate?: string;
      /** @format date */
      departureDate?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 10
       */
      size?: number;
      /**
       * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
       * @default ["reservationDate,DESC"]
       */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminReservationDto[], any>({
      path: `/v1/admin/reservations`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminReservationService
   * @name GetReservation1
   * @summary Get Reservation
   * @request GET:/v1/admin/reservations/{id}
   * @secure
   */
  getReservation1 = (id: number, params: RequestParams = {}) =>
    this.http.request<AdminReservationDto, any>({
      path: `/v1/admin/reservations/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminReservationService
   * @name GetPaymentByReservation1
   * @summary Get Payment By Reservation
   * @request GET:/v1/admin/reservations/{id}/payment
   * @secure
   */
  getPaymentByReservation1 = (id: number, params: RequestParams = {}) =>
    this.http.request<PaymentDto, any>({
      path: `/v1/admin/reservations/${id}/payment`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminReservationService
   * @name GetDaysOfWeek
   * @request GET:/v1/admin/reservations/week
   * @secure
   */
  getDaysOfWeek = (
    query: {
      /** @format date */
      date: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ReservationDayOfWeekDto[], any>({
      path: `/v1/admin/reservations/week`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminReservationService
   * @name GetReservationsByPeriod
   * @summary Get Reservations by period
   * @request GET:/v1/admin/reservations/period
   * @secure
   */
  getReservationsByPeriod = (
    query: {
      /** @format int64 */
      listingId?: number;
      /** @format date */
      fromDate: string;
      /** @format date */
      toDate: string;
      periodType: 'RESERVATION' | 'ARRIVAL' | 'DEPARTURE' | 'CANCELED' | 'CONFIRMATION';
      status?: 'NEW' | 'CONFIRMED' | 'FAILED' | 'CANCELLED';
      onlyGuestNote?: boolean;
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 10
       */
      size?: number;
      /**
       * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
       * @default ["reservationDate,DESC"]
       */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminReservationDto[], any>({
      path: `/v1/admin/reservations/period`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
}
